/* eslint-disable @typescript-eslint/no-explicit-any */
export const createTemporaryActionQueue = (namespace: string) => {
  (window as any)[namespace] = function (...args: any[]) {
    const [action, ...params] = args;
    ((window as any)[namespace].q = (window as any)[namespace].q || []).push([action, ...params]);
  };
};
